import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InformacionesGridComponent } from '../../components/informaciones/informaciones-grid/informaciones-grid.component';

@Component({
  selector: 'app-estadistica-ley',
  standalone: true,
  imports: [CommonModule, InformacionesGridComponent],
  templateUrl: './estadistica-ley.component.html',
  styleUrls: ['./estadistica-ley.component.scss']
})
export class EstadisticaLeyComponent {
}
